import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { commandCrossSelling, commandForbidden } from 'src/app/core/constants/routes';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { devLog } from 'src/app/core/utils/generic-utils';
import { accountHasAddon } from 'src/app/core/utils/global-utils';

@Injectable({
  providedIn: 'root',
})
export class LifecycleCommandGuard {
  constructor(
    private userDataService: UserDataService,
    private permissionsService: PermissionsService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const { company } = await this.userDataService.getUserAndCompany();
      const companyHasAddon = accountHasAddon('lifecycle-command', company?.serviceAddons ?? []);

      if (!companyHasAddon) {
        this.router.navigateByUrl(commandCrossSelling);
        return false;
      }

      if (this.permissionsService.hasAddonAccess('lifecycle-command')) {
        return true;
      }

      this.router.navigateByUrl(commandForbidden);
    } catch (err) {
      devLog(err);
    }

    return false;
  }
}
